import { createEffect, createSignal } from "solid-js";
import { LoadingButton } from "../../components/ui/Button";
import { TextInput } from "../../components/ui/form/TextInput";
import { SelectInput } from "../../components/ui/form/SelectInput";
import ImageUploader from "@/components/ui/ImageUploader";;
import { Modal } from "../../components/ui/Modal";
import { DialogFooter } from "@/components/shadcn/dialog";
import useDutyForm from "../../services/useDutyForm";

export const DutyModal = (props) => {

  const [open, setOpen] = createSignal(false);
  const [title, setTitle] = createSignal('');
  const onClose = (state) => {
    if (typeof props.onClose === 'function') {
      props.onClose();
    }
  }

  const onRefresh = () => {
    if (typeof props.onRefresh === 'function') {
      props.onRefresh();
    }
  }

  const {
    form,
    doctors,
    rooms,
    days,
    times,
    handleInput,
    handleChange,
    handleSave,
    fetchInfo,
    loading,
    fetching,
    clearForm,
  } = useDutyForm({ onClose, onRefresh });

  createEffect(() => {
    props.open;
    setOpen(props.open);
  });

  createEffect(() => {
    props.key;
    if (props.key !== null) {
      fetchInfo(props.key);
      setTitle('Edit Duty');
    } else {
      clearForm();
      setTitle('New Duty');
    }
  });

  return (
    <Modal
      open={open()}
      title={title()}
      onClose={onClose}
      fetching={fetching()}
      hideOnOutsideClick={false}
      error={''}
    >
      <div class="grid gap-2">
        <div class="grid gap-1">
          <SelectInput
            label="Doctor"
            name="doctorId"
            form={form}
            options={doctors()}
            input={handleChange}
          />
        </div>
      </div>
      <div class="grid grid-cols-2 gap-2">
        <div class="grid gap-1">
          <SelectInput
            label="Room"
            name="roomId"
            form={form}
            options={rooms()}
            input={handleChange}
          />
        </div>
        <div class="grid gap-1">
          <SelectInput
            label="Day"
            name="day"
            form={form}
            options={days()}
            input={handleChange}
          />
        </div>
      </div>
      <div class="grid grid-cols-2 gap-2">
        <div class="grid gap-1">
          <SelectInput
            label="Start Time"
            name="startTime"
            form={form}
            options={times()}
            input={handleChange}
          />
        </div>
        <div class="grid gap-1">
          <SelectInput
            label="End Time"
            name="endTime"
            form={form}
            options={times()}
            input={handleChange}
          />
        </div>
      </div>
      <DialogFooter>
        <LoadingButton variant="outline" onClick={() => { handleSave() }} type="button" loading={loading()} disabled={fetching()}>Save</LoadingButton>
      </DialogFooter>
    </Modal>
  );
}
